/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { DELETE_SCHEDULE } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { capitalCase } from "change-case";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDeleteScheduleMethods extends IPluginMethodMap {
  deleteSchedule(args: any): Promise<any>;
}

export class DeleteScheduleService implements IAgentPlugin {
  readonly methods: IDeleteScheduleMethods;

  constructor() {
    this.methods = {
      deleteSchedule: this.deleteSchedule.bind(this),
    };
  }

  async deleteSchedule(args: any) {
    console.log(`deleteSchedule service : `, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: DELETE_SCHEDULE,
          variables: {
            ...args?.payload,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return res?.data?.deleteSchedule;
        }
      }
    } catch (err: any) {
      console.log(`error in create schedule`, err);
      throw err;
      return {
        isEmpty: true,
      };
    }
  }
}
